import {
  GetAuditLogLevelTranslationKey,
  GetStateForAuditLogLevel,
} from "akademika/akamont/utils/AuditLogLevelUtil";

import FilterController from "../sharedControllers/FilterController";
import { Routes } from "../../constants/Routes";

/**
 * @namespace akademika.akamont.pages.logList
 */

export default class LogList extends FilterController {
  route = Routes.LOG_LIST;
  parentRoute = Routes.DASHBOARD;

  onInit() {
    super.onInit();

    const sevenDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    const defaultFilter = {
      timestampFrom: sevenDaysAgo
    };

    this.initFilters(defaultFilter, "api/AuditLog/GetAuditLogList");
  }

  public async onRouteMatched() {
    await this.fetchModel(
      "api/AuditLog/GetAuditLogFilterOptions",
      "filterOptions"
    );
  }

  public async onLogDetails(auditLogId: string) {
    this.navTo(Routes.LOG_DETAILS, { auditLogId: auditLogId });
  }

  public getAuditLogLevelTranslation(logLevel: number) {
    const key = GetAuditLogLevelTranslationKey(logLevel);
    return this.translate(key);
  }

  public getStateForAuditLogLevel = GetStateForAuditLogLevel;
}
